module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./TransferView.js"));
	}, "TransferView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TransferView!./src/pages/Shop/Member/Wallet/Transfer/TransferView.js
// module id = 1067
// module chunks = 438